import React from 'react';
import { Layout } from './components/Layout';
import { Hero } from './components/Hero';
import { WhyNoronha } from './components/Features';
import { IslandGallery } from './components/IslandGallery';
import { ExperienceIncludes } from './components/ExperienceIncludes';
import { Reservas } from './components/Reservas';
import { OrganizadoPor } from './components/OrganizadoPor';
import { Testimonials } from './components/Testimonials';
import { FaqNoronha } from './components/FaqNoronha';
import { FinalCTANoronha } from './components/FinalCTANoronha';
export function App() {
  return <Layout data-id="element-0" data-mp="31agn4l9h89hv">
      <Hero data-id="element-1" data-mp="31b8lu4ydencd" />
      <WhyNoronha data-id="element-2" data-mp="31bs27h8dh3oa" />
      <IslandGallery data-id="element-3" data-mp="31c9w477kb5t1" />
      <ExperienceIncludes data-id="element-4" data-mp="31ctf7r8y808n" />
      <Reservas data-id="element-5" data-mp="2wk9zanmsgt0o" />
      <OrganizadoPor data-id="element-6" data-mp="2wjqgl4pbe0ll" />
      <Testimonials data-id="element-7" data-mp="2wj8g1vvmd07v" />
      <FaqNoronha data-id="element-8" data-mp="2whx9xpepbgdl" />
      <FinalCTANoronha data-id="element-9" data-mp="28ufqch5lbolp" />
    </Layout>;
}